import { cosemApi } from '@services/providers/cosem';
import { ApiPaginationResponse, ApiResponse } from '@services/providers/cosem.types';
import { ETicketType, ETicketTypeToCreate } from './e-ticket-type.types';
import { ActiveFilter } from '@utils/filters';

const eTicketTypeApi = cosemApi.injectEndpoints({
    endpoints: (build) => ({
        getETicketTypes: build.mutation<ApiResponse<ETicketType[]>, undefined>({
            query: () => {
                return { 
                    url: `/product/eticket-types`, 
                    method: 'GET',
                };
            },
            transformResponse: (response: ApiResponse<ETicketType[]>) => response
        }),
        getETicketType: build.mutation<ApiResponse<ETicketType>, { id: string }>({
            query: ({ id }) => {
                return { 
                    url: `/product/eticket-type/${id}`, 
                    method: 'GET',
                };
            },
            transformResponse: (response: ApiResponse<ETicketType>) => response
        }),
        postETicketType: build.mutation<ApiResponse<ETicketType>, ETicketTypeToCreate>({
            query: (eticketType: ETicketTypeToCreate) => {
                return { 
                    url: `/product/eticket-type`, 
                    method: 'POST',
                    body: eticketType
                };
            },
            transformResponse: (response: ApiResponse<ETicketType>) => response
        }),
        putETicketType: build.mutation<ApiResponse<ETicketType>, { id: string; eticketType: ETicketTypeToCreate }>({
            query: ({ id, eticketType }) => {
                return { 
                    url: `/product/eticket-type/${id}`, 
                    method: 'PUT',
                    body: eticketType    
                };
            },
            transformResponse: (response: ApiResponse<ETicketType>) => response
        }),
        deleteETicketType: build.mutation<ApiResponse<void>, { id: string }>({
            query: ({ id }) => {
                return { 
                    url: `/product/eticket-type/${id}`, 
                    method: 'DELETE',
                };
            },
            transformResponse: (response: ApiResponse<void>) => response
        }),

        getUnarchivedETicketType: build.mutation<ApiPaginationResponse<ETicketType>,
        { limit?: number; page?: number; search?: string; orderBy?: string; filters?: ActiveFilter[] }
        >({
            query: ({ limit = 10, page = 1, search, orderBy, filters }) => {
                return {
                    url: `/product/eticket-types/paginated`,
                    method: 'GET',
                    params: { limit, page, search: search ?? '', orderBy: orderBy ?? '', filters: JSON.stringify(filters ?? []) }
                };
            },
            transformResponse: (response: ApiPaginationResponse<ETicketType>) => response
        }),
        getArchivedETicketType: build.mutation<ApiPaginationResponse<ETicketType>,
        { limit?: number; page?: number; search?: string; orderBy?: string; filters?: ActiveFilter[] }
        >({
            query: ({ limit = 10, page = 1, search, orderBy, filters }) => {
                return {
                    url: `/product/eticket-types/archived/paginated`,
                    method: 'GET',
                    params: { limit, page, search: search ?? '', orderBy: orderBy ?? '', filters: JSON.stringify(filters ?? []) }
                };
            },
            transformResponse: (response: ApiPaginationResponse<ETicketType>) => response
        }),
        toggleArchiveETicketType: build.mutation<ApiResponse<ETicketType>, { id: string | number; archived: boolean }>({
            query: ({ id, archived }) => {
                return {
                    url: `/product/eticket-types/${id}/archive`,
                    method: 'PUT',
                    body: { archived }
                };
            },
            transformResponse: (response: ApiResponse<ETicketType>) => response
        }),
    })
});

export const { 
    useGetETicketTypesMutation,
    useGetETicketTypeMutation,
    usePostETicketTypeMutation,
    usePutETicketTypeMutation,
    useDeleteETicketTypeMutation,
    useGetUnarchivedETicketTypeMutation,
    useGetArchivedETicketTypeMutation,
    useToggleArchiveETicketTypeMutation
} = eTicketTypeApi;
